import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'
import { Context } from '../shared'
import {
  VulnerabilityMergeMutationArgs,
  vulnerabilityMergeMutationArgs
} from '../types/vulnerability-merge-mutation-args'

export const mergeVulnerabilities: GraphQLFieldConfig<
  any,
  Context,
  VulnerabilityMergeMutationArgs
> = {
  description: 'Merge vulnerabilities',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: vulnerabilityMergeMutationArgs,
  resolve: async function resolve(
    _source,
    args,
    context
  ): Promise<GenericMutationResponse> {
    const { input } = args

    if (!input) {
      throw new Error('mutation input parameter is required')
    }

    const { ids, organizationID, applicationID, primaryVulnerabilityID } = input

    const { connector } = context

    await connector.put(
      `/${organizationID}/traces/${applicationID}/trace/${primaryVulnerabilityID}/merge`,
      {
        duplicateTraces: ids
      }
    )

    return { _placeholder: true }
  }
}
